import Vue from 'vue';
import App from './App.vue';
// import App from './App1.vue'
import './plugins/iview';
import './plugins/auth';
import router from './router';
import store from './store';

Vue.config.productionTip = false;

// require ('./vendor/fit');

import fit from './vendor/fit';
window.fit = fit;

// require('./vendor/md5')

import './vendor/md5';
import './vendor/utils';
import axios from 'axios';

const AUTH_TOKEN_KEY = 'vue-authenticate.auth_token';
const XSRF_TOKEN_HEADER = 'x-xsrf-token';
const XSRF_STORAGE_KEY = 'btncms_xsrf_token';
const nativeFetch = window.fetch.bind(window);
let xsrfToken = window.sessionStorage.getItem(XSRF_STORAGE_KEY) || null;

if (xsrfToken) {
	axios.defaults.headers.common[XSRF_TOKEN_HEADER] = xsrfToken;
}

function setXsrfToken(token) {
	if (!token) {
		return;
	}

	xsrfToken = token;
	window.sessionStorage.setItem(XSRF_STORAGE_KEY, token);
	axios.defaults.headers.common[XSRF_TOKEN_HEADER] = token;
}

function sendAuthenticatedFetch(input, init = {}, token) {
	const headers = new Headers(typeof input === 'string' ? init.headers : input.headers);

	if (xsrfToken && !headers.has(XSRF_TOKEN_HEADER)) {
		headers.set(XSRF_TOKEN_HEADER, xsrfToken);
	}

	if (!headers.has('Authorization') && token) {
		headers.set('Authorization', `Bearer ${token}`);
	}

	return nativeFetch(new Request(input, {
		...init,
		credentials: init.credentials || 'same-origin',
		headers
	})).then(response => {
		const nextXsrfToken = response.headers.get(XSRF_TOKEN_HEADER);
		if (nextXsrfToken) {
			setXsrfToken(nextXsrfToken);
		}
		return response;
	});
}

window.fetch = function authenticatedFetch(input, init = {}) {
	const url = typeof input === 'string' ? input : input.url;
	const isSameOrigin = !/^https?:\/\//i.test(url) || url.indexOf(window.location.origin) === 0;
	if (!isSameOrigin) {
		return nativeFetch(input, init);
	}

	const token = window.localStorage.getItem(AUTH_TOKEN_KEY);
	const requestMethod = (init.method || (typeof input === 'string' ? 'GET' : (input.method || 'GET'))).toUpperCase();
	const isWriteMethod = requestMethod !== 'GET' && requestMethod !== 'HEAD' && requestMethod !== 'OPTIONS';

	if (isWriteMethod && !xsrfToken) {
		return nativeFetch('/api/auth.captcha', {
			method: 'GET',
			credentials: 'same-origin'
		}).then(response => {
			setXsrfToken(response.headers.get(XSRF_TOKEN_HEADER));
			return sendAuthenticatedFetch(input, init, token);
		});
	}

	return sendAuthenticatedFetch(input, init, token);
};

// console.log('123456'.hashMD5())

// console.log(fit)

// console.log(import ('./vendor/fit'))

// console.log(fit)


// import { ServiceIO } from 'service-io-client';
// import { ServiceIOWS as ServiceIO } from 'service-io-client';
import { ServiceIORest as ServiceIO } from 'service-io-client';

// setTimeout(function () {
// 	console.log(process.env);	
// }, 2000)

const ws = `ws://${window.location.hostname}:${process.env.NODE_ENV == 'development'
	? 3000
	: window.location.port}`;


// leave the export, even if you don't use it
// export default async ({ app, router, Vue }) => {
global.serviceIO = ServiceIO({
	url: ws
});
// }

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app');
